import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { MuiThemeProvider, makeStyles } from "@material-ui/core/styles"
import { CssBaseline, Container } from "@material-ui/core"
import theme from "../theme"
import SiteNavigation from "./SiteNavigation"
import "./Layout.css"
import Footer from "./Footer"

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  // mainContent: {
  //   "& a": {
  //     backgroundColor: "#e7e9fe",
  //     textDecoration: "none",
  //     borderBottom: "1px solid rgba(0,0,0,0.2)",
  //     padding: theme.spacing(0.25, 0.25, 0, 0.25),
  //   },
  // },
  toolbar: theme.mixins.toolbar,
}))

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const classes = useStyles()

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <SiteNavigation siteTitle={data.site.siteMetadata.title} />
      <Container maxWidth="md" className={classes.container}>
        <main>
          <div className={classes.mainContent}>
            <div className={classes.toolbar} />
            {children}
          </div>
        </main>
        <Footer />
      </Container>
    </MuiThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
